import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const LARAVEL_CHAT_API = process.env.REACT_APP_LARAVEL_API

// Async thunk for sending a message
// export const clientSendMessage = createAsyncThunk(
//   "chat/clientSendMessage",
//   async ({ input, id, to_type, token }, { rejectWithValue }) => {
//     try {
//       await axios.post(
//         `${LARAVEL_CHAT_API}/admin/chatify/messages`,
//         {
//           message: input,
//           to_id: id,
//           to_type,
//         },
//         {
//           headers: {
//             Token: token,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const { status, chatId } = response.data;

//       return {
//         id: Date.now(),
//         text: input,
//         sender: "you",
//         chatId,
//       };
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const clientSendMessage = createAsyncThunk(
  "chat/clientSendMessage",
  async ({ input, id, to_type, file, token }, { rejectWithValue }) => {
    try {

      const formData = new FormData();
      formData.append("message", input);
      formData.append("to_id", id);
      formData.append("to_type", to_type);
      if (file) {
        formData.append("file", file); // can be image or PDF
      }

      const response = await axios.post(
        `${LARAVEL_CHAT_API}/admin/chatify/messages`,
        formData,
        {
          headers: {
            Token: token,
            // "Content-Type": "application/json",
          },
        }
      );

      const { chatId } = response.data;

      return {
        id: Date.now(), // temporary local ID
        text: input,
        sender: "you",
        chatId, // this is your server chat ID
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchClientMessages = createAsyncThunk(
  "clientChat/fetchClientMessages",
  async ({ token, id, type }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${LARAVEL_CHAT_API}/admin/chatify/messages/${type}/${id}`,
        {
          headers: { Token: `${token}` },
        }
      );
      console.log("Fetched messages", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch messages");
    }
  }
);

const clientChatSlice = createSlice({
  name: "clientChat",
  initialState: {
    messages: [],
    input: "",
    loading: false,
    error: null,
    chatId: null,
  },
  reducers: {
    setInput(state, action) {
      state.input = action.payload;
    },
    addClientMessage(state, action) {
      state.messages.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clientSendMessage.fulfilled, (state, action) => {
        state.messages.push({
          id: action.payload.id,
          text: action.payload.text,
          sender: action.payload.sender,
        });
        state.input = "";

        if (action.payload.chatId) {
          state.chatId = action.payload.chatId;
        }
      })
      .addCase(clientSendMessage.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchClientMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.map((msg) => ({
          id: msg.id,
          text: msg.message,
          file_path: msg.file_path,
          file_name: msg.file_name,
          profile_image:
            msg.from_type === "Icommunetech\\Client\\Models\\Client" &&
            msg.from_id.toString() === localStorage.getItem("user_id")
              ? msg.from.profile_image
              : "",
          sender:
            msg.from_type === "Icommunetech\\Client\\Models\\Client" &&
            msg.from_id.toString() === localStorage.getItem("user_id")
              ? "you"
              : "other",
          timestamp: msg.created_at
        }));
      })
      .addCase(fetchClientMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setInput, addClientMessage } = clientChatSlice.actions;

export default clientChatSlice.reducer;
